const EditLimitCell = ({ params }) => {

  const handleInputChange = (e) => {
    
    params.api.setEditCellValue({id: params.id, field: params.field, value: e.target.value});

  };

  return (
    <div>
      <input 
        type="text"
        value={params.value}
        size="1"
        onInput={(e) => {e.target.value = e.target.value.replace(/[^0-9]/g, '');}}
        onChange={handleInputChange}
      /> 
    </div>
  );
};

export default EditLimitCell;